import { MutableRefObject } from 'react'
import { HtmlPatcher } from './patcher/htmlPatcher'

const getStyledComponentCss = () => {
  const styleElement = document.createElement('style')

  const style = document.querySelector('style[data-styled="active"]') as HTMLStyleElement
  if (!style || !style.sheet) {
    return styleElement
  }

  const { cssRules } = style.sheet
  Array.from(cssRules).forEach((rule) => {
    styleElement.appendChild(document.createTextNode(rule.cssText))
  })

  return styleElement
}

export const getClonedHead = () => {
  const clonedHead = document.getElementsByTagName('head')[0].cloneNode(true) as Element
  clonedHead.appendChild(getStyledComponentCss())

  return clonedHead
}

const hideElement = (cloneBody: Element, className: string) => {
  const element = cloneBody.getElementsByClassName(className)[0]
  element.setAttribute('style', 'display: none')
}

export const getClonedBody = (
  refObjectToHide: MutableRefObject<HTMLDivElement>[],
  patchers: HtmlPatcher[]
) => {
  patchers.forEach((patcher) => patcher.preprocess())

  const clonedBody = document.getElementsByTagName('body')[0].cloneNode(true) as Element
  refObjectToHide.forEach((refObject) => {
    hideElement(clonedBody, refObject.current.className)
  })

  const tooltip = clonedBody.querySelector(`[data-testid="tooltip-body-full"]`)
  if (tooltip) {
    tooltip.setAttribute('style', 'display: none')
  }

  const dialogs = clonedBody.getElementsByClassName('MuiDialog-root MuiModal-root')
  Array.from(dialogs).forEach((dialog) => {
    dialog.setAttribute('style', 'display: none')
  })

  const hotjar = clonedBody.getElementsByClassName('_hj-widget-container')
  if (hotjar.length > 0) {
    hideElement(clonedBody, '_hj-widget-container')
  }

  // * patch for dashboard view layout removing header, action list and side panel
  const dashboardViewLayout = clonedBody.getElementsByClassName('dashboard-view-layout')
  if (dashboardViewLayout.length > 0) {
    // @ts-ignore
    dashboardViewLayout[0].style.gridTemplateColumns = '0 0 1fr'
    // @ts-ignore
    dashboardViewLayout[0].style.gridTemplateRows = '0 0 1fr'
    // @ts-ignore
    dashboardViewLayout[0].style.height = 'unset'
    // @ts-ignore
    dashboardViewLayout[0].style.minHeight = '100vh'
    const targetEls = Array.from(dashboardViewLayout[0].childNodes)
    targetEls.forEach((el) => {
      // @ts-ignore
      if (el.className !== 'dashboard') {
        el.remove()
      }
    })
  }

  // * patch for action list menu dropdown while exporting pdf
  const ellipsisButtonMenu = clonedBody.querySelectorAll('[data-testid=menu]')
  if (ellipsisButtonMenu.length > 0) {
    const targetEls = Array.from(ellipsisButtonMenu)
    targetEls.forEach((el) => el.remove())
  }

  patchers.forEach((patcher) => patcher.patch(clonedBody))

  return clonedBody
}
